import useSWR from "swr";
import { SplatCheckoutDocumentType } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { getDocumentStatus } from "services/prospect";
import { useAuthToken } from "hooks/useAuthToken";

const useDocumentStatus = (
  shouldFetch: boolean,
  prospectId: string,
  proposalId: string,
  documentType?: SplatCheckoutDocumentType
) => {
  const authKey = useAuthToken("HYBRID")?.token ?? "";
  const proposalToken = useAuthToken("PROPOSAL")?.token;
  const { data, error, isLoading } = useSWR(
    shouldFetch &&
      documentType && [
        `Get Document Status`,
        prospectId,
        proposalId,
        documentType,
      ],
    () =>
      getDocumentStatus({
        authKey: authKey || proposalToken || "",
        prospectId,
        proposalId,
        // If documentType is undefined, we skip the request. It's safe to assert here because we check for documentType above.
        documentType: documentType!,
        isCustomer: !!proposalToken,
      })
  );
  return { data, error, isLoading };
};

export { useDocumentStatus };
